import { isArray, isString } from "@visactor/vutils";

export function getGroupByDataConfig(groupByOption) {
    if (isString(groupByOption)) return {
        groupByRules: [ groupByOption ]
    };
    if (isArray(groupByOption)) {
        return {
            groupByRules: groupByOption.map((item => isString(item) ? item : item.key))
        };
    }
    return {};
}
//# sourceMappingURL=group-helper.js.map